module.exports = __webpack_public_path__ + "static/media/CompletingTheApplication.0aae7d52.svg";